/** Окно «Переслать в салон» в «Чатах»: тип запроса, фото чата, город —
 * `GET /api/chats/{id}/podbor/form`, `POST /api/chats/{id}/podbor`. */
import { apiFetch } from "@/lib/api";
import type { Podbor } from "@/lib/podbor";

/** Что клиент хочет: подобрать платье по фото или сдать свой наряд (платье, костюм, обувь, аксессуары). */
export type PodborKind = "podbor" | "dress";

export type PodborForm = {
  kinds: { id: PodborKind; name: string; hint: string }[];
  /** Тип по умолчанию — по теме чата (тег «сдать платье»). */
  kind: PodborKind;
  /** Город чата, если в нём есть салон и группа; `null` — выбрать руками. */
  city: number | null;
  /** Города с салоном и группой Telegram, куда уйдёт запрос; `kinds` — только для этих типов
   * (последним — `id: 0` «Все города», общий чат приёма платьев, только «Сдать наряд»). */
  cities: { id: number; name: string; group: string; kinds?: PodborKind[] }[];
  /** Фото клиента из чата, свежие первыми; `sent` — уже пересылали в салон. */
  photos: { message_id: number; thumb: string; date: string; sent: boolean }[];
};

export const loadPodborForm = (chatId: number) => apiFetch<PodborForm>(`/api/chats/${chatId}/podbor/form`);

/** Выбранные фото — в группу салона города; ответ — заведённый запрос. */
export const forwardToSalon = (chatId: number, body: { kind: PodborKind; city: number; messages: number[]; question: string }) =>
  apiFetch<{ podbor: Podbor }>(`/api/chats/${chatId}/podbor`, { method: "POST", body: JSON.stringify(body) });
